import { getPlayingAgeRangeTitle } from "shared-utils";
import { TFunction } from "i18n";
import {
  IPrepareRoleTexts,
  IRoleDisabilityTranslationMapping,
  prepareAppearance,
  prepareDisability,
  prepareGender,
  prepareHeightRange,
  preparePlayingAge,
  prepareRoleTitle,
} from "shared/helpers/breakdownViewHelpers";
import { findFacetName } from "shared/helpers/facetHelpers";
import { IBreakdownRole } from "shared/models/breakdown";
import { IFacetGroup } from "shared/models/facet";

import { ICountry } from "shared/models/location";
import { IBreakdownViewRole } from "components/BreakdownView/BreakdownView";

export interface IPrepareBreakdownViewData {
  productionTypes: IFacetGroup[];
  contractTypes: IFacetGroup[];
  genders: IFacetGroup[];
  appearances: IFacetGroup[];
  disabilities: IFacetGroup[];
  countries: ICountry[];
}

export interface IPrepareRoleProps {
  breakdownRole: IBreakdownRole;
  prepareBreakdownViewData: IPrepareBreakdownViewData;
  texts: IPrepareRoleTexts;
  roleDisabilityTranslationMapping: IRoleDisabilityTranslationMapping;
  t: TFunction;
  isYPPlayingAgeEnabled?: boolean;
}

export function prepareRole({
  breakdownRole,
  prepareBreakdownViewData,
  texts,
  roleDisabilityTranslationMapping,
  t,
  isYPPlayingAgeEnabled,
}: IPrepareRoleProps): IBreakdownViewRole {
  const { role } = breakdownRole;
  const playingAge = isYPPlayingAgeEnabled
    ? getPlayingAgeRangeTitle(role.minimumPlayingAge, role.maximumPlayingAge, t)
    : preparePlayingAge(
        role.minimumPlayingAge,
        role.maximumPlayingAge,
        texts.roleAnyPlayingAge,
        texts.rolePlayingAgeFormat
      );

  return {
    id: role.id,
    title: prepareRoleTitle(
      role,
      prepareBreakdownViewData.genders,
      texts,
      playingAge
    ),
    description: role.description,
    anyEthnicity: role.anyEthnicity,
    ethnicityLabel: role.ethnicityLabel,
    playingAge,
    height: prepareHeightRange(
      role.minimumHeight,
      role.maximumHeight,
      texts.roleAnyHeight
    ),
    appearance: prepareAppearance(
      role,
      prepareBreakdownViewData.appearances,
      texts.roleAnyAppearance
    ),
    gender: prepareGender(
      role,
      prepareBreakdownViewData.genders,
      texts.roleAnyGender
    ),
    disability: prepareDisability(
      role,
      prepareBreakdownViewData.disabilities,
      roleDisabilityTranslationMapping
    ),
    contractType: findFacetName(
      prepareBreakdownViewData.contractTypes,
      role.contractTypeId
    ),
    contractTypeInfo: breakdownRole.role.contractTypeInfo,
    linkAttachments: role.linkAttachments,
    genderIds: role.genderIds,
    appearanceIds: role.appearanceIds,
    isCast: role.isCast,
  };
}
